import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { stringify } from "querystring";
import { Observable } from "rxjs";

import { environment } from '../../../../environments/environment';
import { MonthOptions } from "../../../shared/month-select/month-select.component";
import { YearOptions } from "../../../shared/year-select/year-select.component";
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public initializeProfile(clientId, email: string, userId: string): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/initializeProfile',
      {
        clientId,
        email,
        userId
      },
      { headers });
  }

  public updateProfileCredentials(email, companyProfileUuid): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateProfileCredentials',
      {
        email,
        companyProfileUuid
      },
      { headers });
  }

  public sendSuspendContractNotification(userId, clientEmails, subject, body) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/sendSuspendContractNotification',
      {
        userId,
        clientEmails,
        subject,
        body
      },
      { headers });
  }

  public sendTerminationContractNotification(userId, clientEmails, subject, body, terminationType, contractId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/sendTerminationContractNotification',
      {
        userId,
        clientEmails,
        subject,
        body,
        terminationType,
        contractId
      },
      { headers });
  }

  public getDataFromFinance(bodyData: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/getDataFromMinisterulFinantelor',
        {data: bodyData}, {headers});
  }

  public getDataFromMinisterulFinantelorRegistruCulte(bodyData: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/getDataFromMinisterulFinantelorRegistruCulte',
        {data: bodyData}, {headers});
  }

  public generateSignatureLink(contract: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/generateSignatureLink',
        { contract }, { headers });
  }

  public setSvpFromTDEC(payload: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/setSvpFromTDEC',
        { clientCui: payload.clientCui, spv: payload.spv }, { headers });
  }

  public setNewPortofolio(userId, teamId, clientId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/setNewPortofolio',
        { userId, teamId, clientId }, { headers });
  }

  public setPortofolioSimulation(userId, teamId, clientId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/setPortofolioSimulation',
        { userId, teamId, clientId }, { headers });
  }

  public goLivePortofolioSimulation() {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/goLivePortofolioSimulation',
        { }, { headers });
  }

  public downloadContract(clientId: any, filename: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/downloadContract',
        { clientId, filename }, { headers });
  }

  public getContractForSigning(id: string): Observable<any> {
    const params = new HttpParams()
        .set('signatureHashId', id);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getContractForSigning', { params });
  }

  public getContractByOfferId(offerId: string): Observable<any> {
    const params = new HttpParams()
        .set('offerId', offerId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getContractByOfferId', { params });
  }

  public getContractForTerminationSigning(id: string): Observable<any> {
    const params = new HttpParams()
        .set('signatureHashId', id);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getContractForTerminationSigning', { params });
  }

  public getSignatureHash(id: string): Observable<any> {
    const params = new HttpParams()
        .set('signatureHashId', id);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getSignatureHash', { params });
  }

  public requestSagaUpdate(clientId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/requestSagaUpdate',
        { clientId },
        { headers });
  }

  public forceSyncGoogleDrive(clientId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/invalidateGoogleDriveStatusForClient',
        { clientId },
        { headers });
  }

  public sendBusinessCardEmail(clientId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/sendBusinessCardEmail/123_ascon',
        { clientId },
        { headers });
  }

  public addClient(client: any, userId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/addClient',
        {client, addedBy: userId},
        { headers });
  }

  public updateClient(client: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClient',
        {client},
        { headers });
  }

  public updateClientAddress(client: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClientAddress',
        { client },
        { headers });
  }

  public updateClientVatStatus(clientId, vatStatus) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClientVatStatus',
        { clientId, vatStatus },
        { headers });
  }

  public updateClientVatDate(clientId, vatDate, tvaLaIncasare) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClientVatDate',
        { clientId, vatDate, tvaLaIncasare },
        { headers });
  }

  public updateClientRegistrationDate(clientId, registrationDate) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClientRegistrationDate',
        { clientId, registrationDate },
        { headers });
  }

  public updateClientFromAssoc(client: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClientFromAssoc',
        {client},
        { headers });
  }

  public setLoggedHours(clients: any[], month: MonthOptions, year: YearOptions) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/setLoggedHours',
        {clients, month, year},
        { headers });
  }

  public setTeamId(clients: any[], teamId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/setTeamId',
        {clients, teamId},
        { headers });
  }

  public getClients(search: string) {
    const params = new  HttpParams()
      .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForLog', {params});
    // return this.httpClient.get(this.SERVER_URL + 'client/client/getClients', {params});
  }

  public getClientsRedux(userId: string) {
    const params = new HttpParams()
      .set('userId', userId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsRedux', {params});
  }

  public getContractHistory(contractId: any){
    const params = new HttpParams()
    .set('contractId', contractId);

    return this.httpClient.get(this.SERVER_URL + 'contracts/contracts/getContractHistory', {params});
  }

  public getLoggedHours(month: number, year: number) {
    const params = new  HttpParams()
        .set('month', month.toString())
        .set('year', year.toString());

    return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getLoggedHoursPerMonth', {params});
  }

  public getClientById(clientId: string): Observable<any> {
    const params = new  HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientById', {params});
  }

  public getAffiliationsByName(affiliationName: string) {
    const params = new  HttpParams()
          .set('affiliationName', affiliationName);

      return this.httpClient.get(this.SERVER_URL + 'client/client/getAffiliationsByName', {params});
  }

  public getDriveFolders(clientId: string) {
    const params = new  HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getDriveFolders', {params});
  }

  public checkFiscalCode(clientId: string, fiscalCode: string) {
    const params = new  HttpParams()
        .set('clientId', clientId)
        .set('fiscalCode', fiscalCode);

    return this.httpClient.get(this.SERVER_URL + 'client/client/checkFiscalCode', {params});
  }

  public getEmployeeById(employeeId: string, clientId: string) {
    const params = new  HttpParams()
        .set('employeeId', employeeId)
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getEmployeeForClient', {params});
  }

  public getNoContractClients() {
    return this.httpClient.get(this.SERVER_URL + '/client/client/getWithoutContract');
  }

  public getWithoutTeam() {
    return this.httpClient.get(this.SERVER_URL + '/client/client/getWithoutTeam');
  }

  public getWithOldUnpaidInvoices(months: number) {
    const params = new HttpParams()
    .set('months', months.toString());

    return this.httpClient.get(this.SERVER_URL + '/client/client/getWithOldUnpaidInvoices', {params});
  }

  public getWithDebtGreaterThan(minDebt: number) {
    const params = new HttpParams()
    .set('min-debt', minDebt.toString());

    return this.httpClient.get(this.SERVER_URL + '/client/client/getWithDebtGreaterThan', {params});
  }

  public getActiveWithoutEmail() {
    return this.httpClient.get(this.SERVER_URL + '/client/client/getActiveWithoutEmail');
  }

  public getAlerts() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAlerts', {params});
  }

  public getClientEmployees(clientId: string) {
    const params = new  HttpParams()
      .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientEmployees', {params});
  }

  public getAdministrator(clientId: string) {
    const params = new  HttpParams()
      .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAdministrator', {params});
  }

  public getFile(fileId) {
    const params = new HttpParams()
      .set('fileId', fileId)

    return this.httpClient.get(this.SERVER_URL + 'files/files/getFile', {params});
  }

  public getPersonFiles(personId: string) {
    const params = new  HttpParams()
        .set('personId', personId);

    return this.httpClient.get(this.SERVER_URL + 'person/person/getPersonFiles', {params});
  }

  public getClientFiles(clientId: string) {
    const params = new  HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientFiles', {params});
  }

  public uploadPersonFile(id:string, name:string, file:string, addedBy:string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'person/person/uploadPersonFile',
        {personId:id, name, file, addedBy},
        { headers });
  }

  public uploadClientFile(id:string, name:string, file:string, addedBy:string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/uploadClientFile',
        {clientId:id, name, file, addedBy},
        { headers });
  }

  public deletePersonFile(fileId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'person/person/deletePersonFile',
        {fileId},
        { headers });
  }

  public deleteClientFile(fileId:string){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteClientFile',
        {fileId},
        { headers });
  }

  public getPersonById(personId: string): Observable<any> {
    const params = new  HttpParams()
        .set('personId', personId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getPersonById', {params});
  }

  public getPersonsByIds(personIds: string) {
    const params = new  HttpParams()
        .set('personIds', personIds);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getPersonsByIds', {params});
  }

  public getAllPersons() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllPersons', {params});
  }

  public getPersonsForAutocomplete(search: any) {
    const params = new  HttpParams()
        .set('search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getPersonsForAutocomplete', {params});
  }

  public getClientsForAutocomplete(search: any) {
    const params = new  HttpParams()
        .set('search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForAutocomplete', {params});
  }

  public getClientsForWorksheets(search: string): Observable<any> {
    const params = new  HttpParams()
        .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForWorksheets', {params});
  }

  public getClientsForPlans(search: string): Observable<any> {
    const params = new  HttpParams()
        .set('search', search);
    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForPlans', {params});
  }

  public getEmployeesForClient(clientId: string) {
    const params = new  HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getEmployeesForClient', {params});
  }

  public getClientsForOrc() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForOrc', {params});
  }

  public getClientsForEuFunds() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForEuFunds', {params});
  }

  public getClientsForContracts() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForContracts', {params});
  }

  public getClientsForUserForWorksheets(search: string, userId: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('_userId', userId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForUserForWorksheets', {params});
  }

 
  public getClientIbanRegion(clientId: any) {
    const params = new  HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientIbanRegion', {params});
  }

  public getClientsForSaga() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForSaga', {params});
  }

  public getAllClientsWithoutAdministrative(search: string) {
    const params = new  HttpParams()
        .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllClientsWithoutAdministrative', {params});
  }

  public getAllClientsPayrollsWithoutAdministrativeByMonth(search: string, month: string, year: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('month', month)
        .set('year', year);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllClientsPayrollsWithoutAdministrativeByMonth', {params});
  }

  public getAllClientsWithoutAdministrativeByMonth(search: string, month: string, year: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('month', month)
        .set('year', year);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllClientsWithoutAdministrativeByMonth', {params});
  }

  public getAllClientsWithoutAdministrativeWithTarrifs(search: string) {
    const params = new  HttpParams()
        .set('_search', search);

    return this.httpClient.get(this.SERVER_URL +
        'client/client/getAllClientsWithoutAdministrativeWithTarrifs', {params});
  }

  public getClientsWithoutAdministrative(search: string) {
    const params = new  HttpParams()
        .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsWithoutAdministrative', {params});
  }

  public getClientsWithoutAdministrativeForWorksheet(search: string) {
    const params = new  HttpParams()
        .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsWithoutAdministrativeForWorksheet', {params});
  }

  public getCovidClients(search: string, year: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('_year', year);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getCovidClients', {params});
  }

  public getClientsIndicators(search: string, year: string, semester: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('_year', year)
        .set('_semester', semester);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsIndicators', {params});
  }

  public importClientsIndicators(data: any[], addedBy: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    });

    return this.httpClient.post(
      this.SERVER_URL + 'client/client/importClientsIndicators',
      {
        data,
        addedBy
      },
      { headers }
    );
  }

  public getClientsForUser(search: string, userId: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('_userid', userId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForUser', {params});
  }

  public getWorkingPlaces(clientId: string) {
    const params = new  HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getWorkingPlaces', {params});
  }

  public getAllClients() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClients', {params});
  }

  public deleteLog(logId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteLog',
        {logId},
        { headers });
  }

  public deleteClient(clientId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteClient',
        {clientId},
        { headers });
  }

  public deleteEmployee(clientId: string, employeeId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteEmployee',
        {clientId, employeeId},
        { headers });
  }

  public importClients(data) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/importClients',
        {data},
        { headers });
  }

  public importDataClients(data) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/importDataClients',
        {data},
        { headers });
  }

  public deleteWorkingPlace(id: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteWorkingPlace',
        {id},
        { headers });
  }

  public getLogsForUser(userId: any, date: any) {
    const params = new  HttpParams()
        .set('_userId', userId)
        .set('_date', date);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getLogsForUser', {params});
  }

  public updateStartEndTime(logId: any, starttime: any, endtime: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateStartEndTime',
        {
          logId,
          starttime,
          endtime,
          start_hour: moment(starttime).format('HH:mm'),
          end_hour: moment(endtime).format('HH:mm')
        },
        { headers });
  }

  public createLog(log: any) {
    const postLog = {
      date: log.label,
      starttime: log.startTime,
      endtime: log.endTime,
      start_hour: moment(log.startTime).format('HH:mm'),
      end_hour: moment(log.endTime).format('HH:mm'),
      observations: '',
      clientId: log.firmId,
      month: moment(log.startTime).format('MM'),
      year: moment(log.startTime).format('YYYY'),
      introducere: '0',
      verificare: '0',
      balanta: '0',
      addedBy: log.userId
    };
    if (!log.endTime) {
      postLog.end_hour = null;
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/createLog',
        postLog,
        { headers });
  }

  public stopLog(log: any, endtime: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/stopLog',
        {
          logId: log.id,
          end_hour: moment(endtime).format('HH:mm'),
          endtime},
        { headers });
  }

  public updateObservation(log: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateObservation',
        {
          logId: log.id,
          observation: log.observations},
        { headers });
  }

  public getEmployees() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getEmployees', {params});
  }

  public getCaens(): Observable<any> {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getCaens', {params});
  }

  public getAllEmployees() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllEmployees', {params});
  }

  public editClient(clientId: any, value: any, field: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/editClient',
      {value, clientId, field},
      { headers });
  }

  public editClientCaen(clientId: any, value: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/editClientCaen',
        {value, clientId},
        { headers });
  }

  public editClientYearly(clientId: any, value: any, field: string, year: string, semester: string, userId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/editClientYearly',
        {value, clientId, field, year, semester, userId},
        { headers });
  }

  public editClientCovid(clientId: any, value: any, field: string, year: string, userId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/editClientCovid',
        {value, clientId, field, year, userId},
        { headers });
  }

  public editIncome(id: string, value: number, assignedDate: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/editIncome',
      {id, value, assignedDate},
      { headers });
  }

  public saveNegotiatedPrice(value: string, clientId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/saveNegotiatedPrice',
      {value, clientId},
      { headers });
  }

  public saveContractDateNumber(clientId: string, contractDateNumber: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/saveContractDateNumber',
      {clientId, contractDateNumber},
      { headers });
  }

  public saveTva(clientId: string, tvaId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveTva',
      {clientId, tvaId},
      { headers });
  }

  public saveSal(clientId: string, salId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveSal',
      {clientId, salId},
      { headers });
  }

  public saveTax(clientId: string, taxId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveTax',
      {clientId, taxId},
      { headers });
  }

  public setVatStatusPerYear(client: any, year) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/setVatStatusPerYear',
      {
        clientId: client.id,
        achizitiiIntracomunitare: client?.achizitiiIntracomunitare?.toString(),
        d700: client?.d700?.toString(),
        cifraAfaceri: client?.cifraAfaceri,
        vatId: client?.vatId,
        status: client?.status,
        observations: client?.observations,
        year},
      { headers });
  }

  public getVatStatusByYear(year) {
    const params = new  HttpParams()
      .set('year', year);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getVatStatusByYear', {params});
  }

  public exportIncomesWithSelectedColumns(columns: any[], year: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/exportIncomesWithSelectedColumns',
      {columns: columns.join(','), year},
      { headers });
  }

  public saveEmployee(empl: any, userId: string, clientId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const employee = {
      clientId: clientId,
      firstname: empl.firstname,
      lastname: empl.lastname,
      address: empl.address,
      cnp: empl.cnp,
      identity_series: empl.identitySeries,
      employment_date: empl.employmentDate,
      id_card_date: empl.idCardDate,
      id_card_issuer: empl.issuer,
      work_permit: empl.workPermit,
      residence_permit: empl.residencePermit,
      passport: empl.passport,
      userId: userId
    };
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveEmployee',
        employee,
        { headers });
  }

  public updatePerson(empl: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const employee = {
      person: empl
    };
    return this.httpClient.post(this.SERVER_URL + 'client/client/updatePerson',
        employee,
        { headers });
  }

  public saveWorkingPlace(workginPlace: any, userId: string, clientId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const employee = {
      clientId: clientId,
      address: workginPlace.address,
      fiscal_code: workginPlace.fiscal_code,
      iban: workginPlace.iban,
      idIbanRegion: workginPlace.idIbanRegion,
      userId: userId
    };
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveWorkingPlace',
        employee,
        { headers });
  }

  public updateWorkingPlace(workginPlace: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const employee = {
      id: workginPlace.id,
      address: workginPlace.address,
      fiscal_code: workginPlace.fiscal_code,
      iban: workginPlace.iban,
      idIbanRegion: workginPlace.idIbanRegion,
    };
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateWorkingPlace',
        employee,
        { headers });
  }

  public updateAdministrator(person: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateAdministrator',
        {person},
        { headers });
  }

  public addAdministrator(person: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/addAdministrator',
        {person},
        { headers });
  }

  public importEmployees(employees: any[], clientId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/importEmployees',
        { employees, clientId}, { headers });
  }

  public insertAlert(clientId, name, type, description) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/insertAlert',
        {
          clientId,
          name,
          type,
          description
        },
        { headers });
  }

  public sendDeclarationEmail(userId, clientId, toEmail, fromEmail, subject, body, files, formId) {
    const params = new  HttpParams()
        .set('userId', userId)
        .set('clientId', clientId)
        .set('toEmail', toEmail)
        .set('fromEmail', fromEmail)
        .set('subject', subject)
        .set('body', body)
        .set('files', files)
        .set('formId', formId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/sendDeclarationEmail', {params});
  }

  public getPrestators() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getPrestators', {params});
  }

  public getContractsRedux(userId: any){
    const params = new  HttpParams()
      .set('userId', userId);

    return this.httpClient.get(this.SERVER_URL + 'contracts/contracts/getContractsRedux', {params});
  }

  public getContracts(prestatorId: any, clientId: any, startTime: any, endTime: any, documentId: any, status: any, frequencies: any, type: any) {
    const params = new  HttpParams()
      .set('prestatorId', prestatorId ? prestatorId : '')
      .set('clientId', clientId ? clientId : '')
      .set('startTime', startTime)
      .set('endTime', endTime)
      .set('status', status ? status: '')
      .set('invoiceFrequency', frequencies ? frequencies: '' )
      .set('type', type ? type: '');

    return this.httpClient.get(this.SERVER_URL + 'contracts/contracts/getContracts', {params});
  }

  public saveContract(contract: any, userId) {
      const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
      return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/saveContract',
          {
              contract: contract,
              userId: userId
          },
          { headers });
  }

  public updateContract(contract: any, userId: any) {
      const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
      return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/updateContract',
          {
              contract,
              userId
          },
          { headers });
  }

  public deleteContract(contractId: string, userId) {
      const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
      return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/deleteContract',
          {
              contractId: contractId,
              userId: userId
          },
          { headers });
  }

  public getLastContractNumberForPrestator(prestatorId: any) {
      const params = new HttpParams()
        .set('prestatorId', prestatorId);

      return this.httpClient.get(this.SERVER_URL + 'contracts/contracts/getLastContractNumberForPrestator', {params});
  }

  public getContractByPrestatorAndClient(prestatorId: any, clientId: any) {
    const params = new HttpParams()
        .set('prestatorId', prestatorId)
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'contracts/contracts/getContractByPrestatorAndClient', {params});
  }

  public sendContractEmail(contractId, userId, clientId, toEmail, fromEmail, subject, body, file, files, formId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const formData: FormData = new FormData();
    formData.append('file', file, `${file.name}`);
    formData.append('userId', userId);
    formData.append('clientId', clientId);
    formData.append('subject', subject);
    formData.append('body', body);
    formData.append('contractId', contractId);
    formData.append('files', files);
    formData.append('formId', formId);

    return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/sendContractEmail', formData,
        {
          reportProgress: true,
          responseType: 'json'
        });
  }

  public sendSignedContractEmail(contractId, clientId, toEmail,
                                 subject, body, filename, signature, documentCopyId, contractsChanges) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const formData: FormData = new FormData();
    formData.append('fileName', filename);
    formData.append('clientId', clientId);
    formData.append('subject', subject);
    formData.append('body', body);
    formData.append('contractId', contractId);
    formData.append('signature', signature);
    formData.append('documentCopyId', documentCopyId);
    formData.append('contractsChanges', JSON.stringify(contractsChanges));

    return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/sendSignedContractEmail', formData,
        {
          reportProgress: true,
          responseType: 'json'
        });
  }

  public sendCesiuneEmail(contractId, clientId, subject, body, filename, contractsChanges, signatureHashId, cestiuneDate, cesiuneDateUnix) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const formData: FormData = new FormData();
    formData.append('fileName', filename);
    formData.append('clientId', clientId);
    formData.append('subject', subject);
    formData.append('body', body);
    formData.append('contractId', contractId);
    formData.append('signatureHashId', signatureHashId);
    formData.append('cesiuneDateUnix', cesiuneDateUnix);
    formData.append('cesiuneDate', cestiuneDate);
    formData.append('contractsChanges', JSON.stringify(contractsChanges));

    return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/sendCesiuneEmail', formData,
        {
          reportProgress: true,
          responseType: 'json'
        });
  }

  public sendSignedTerminationContractEmail(contractId, clientId,
                                 subject, body, filename, signature, documentCopyId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const formData: FormData = new FormData();
    formData.append('fileName', filename);
    formData.append('clientId', clientId);
    formData.append('subject', subject);
    formData.append('body', body);
    formData.append('contractId', contractId);
    formData.append('signature', signature);
    formData.append('documentCopyId', documentCopyId);

    return this.httpClient.post(this.SERVER_URL + 'contracts/contracts/sendSignedTerminationContractEmail', formData,
      {
        reportProgress: true,
        responseType: 'json'
      });
  }

  public sendUnsignedContractEmail(
    contractId,
    contractFullNumber,
    clientId,
    url,
    hash,
    subject,
    primaryEmail,
    additionalDocChangeIds,
    language
  ) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const formData: FormData = new FormData();

    formData.append('clientId', clientId);
    formData.append('contractFullNumber', contractFullNumber);
    formData.append('url', url);
    formData.append('hash', hash);
    formData.append('subject', subject);
    formData.append('contractId', contractId);
    formData.append('primaryEmail', primaryEmail);
    formData.append('additionalDocChangeIds', additionalDocChangeIds);
    formData.append('language', language);

    return this.httpClient.post(
      this.SERVER_URL + 'contracts/contracts/sendUnsignedContractEmail',
      formData,
      { reportProgress: true, responseType: 'json' }
    );
  }

  public generateFile(clientId, content, filename) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    const formData: FormData = new FormData();

    formData.append('content', content);
    formData.append('fileName', filename);
    formData.append('clientId', clientId);

    return this.httpClient.post(this.SERVER_URL + 'client/client/generateFile', formData,
      {
        reportProgress: true,
        responseType: 'json'
      });
  }

  public getClientsWith473Problems() {
    return this.httpClient.get(this.SERVER_URL + '/client/client/getClientsWith473Problems');
  }
  
  public getClientsWith5125Problems() {
    return this.httpClient.get(this.SERVER_URL + '/client/client/getClientsWith5125Problems');
  }

  public getInactiveClients(search: string) {
    const params = new  HttpParams()
      .set('_search', search);
    return this.httpClient.get(this.SERVER_URL + '/client/client/getInactiveClients', {params});
  }

  public updateInactiveClient(clientId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateInactiveClient',
        { clientId },
        { headers });
  }

  public blockAccessToClient(clientId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/blockAccessToClient',
        { clientId },
        { headers });
  }

  public getSagaAccountsForClient(clientId) {
    const params = new HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getSagaAccountsForClient', {params});
  }

  public markClientForDueInvoicesNotification(clientId, shouldNotify:boolean){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/markClientForDueInvoicesNotification',
        { clientId, shouldNotify },
        { headers });
  }

  public getSagaRegistruForClient(clientId){
    const params = new HttpParams()
        .set('clientId', clientId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getSagaRegistruForClient', {params});
  }

  public getUsersByCompany() {
    const params = new HttpParams()
    return this.httpClient.get(this.SERVER_URL + 'company-user/CompanyUser/getUsersByCompany', {params});
  }

  public addUserProfileByClient(companyProfileUuid, clientId, formData): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
  
    const body = {
      ...formData,         
      companyProfileUuid,   
      clientId
    };

    return this.httpClient.post(
      this.SERVER_URL + 'company-user/CompanyUser/addUserProfileByClient',
      body,
      { headers }
    );
  }

  public getAssignableInvoiceSeries(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(
      this.SERVER_URL +
        'company-user/CompanyUser/getAssignableInvoiceSeries',
      { params }
    );
  }

  public getLoggedUserAllowedInvoiceSeries(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(
      this.SERVER_URL +
        'company-user/CompanyUser/getLoggedUserAllowedInvoiceSeries',
      { params }
    );
  }

  public editUserProfileByClient(companyProfileUuid, clientId, uuid, formData): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
  
    const body = {
      ...formData,         
      companyProfileUuid,   
      clientId,
      uuid
    };

    return this.httpClient.post(
      this.SERVER_URL + 'company-user/CompanyUser/editUserProfileByClient',
      body,
      { headers }
    );
  }

  public getUserPermissions(){
    const params = new HttpParams()
    return this.httpClient.get(this.SERVER_URL + 'company-user/CompanyUser/getUserPermissions', {params});
  }

  public getAvailableClientPermissions(){
    const params = new HttpParams()
    return this.httpClient.get(this.SERVER_URL + 'company-user/CompanyUser/getAvailableClientPermissions', {params});
  }

  public getLoggedUserToCompanyPermissions(){
    const params = new HttpParams()
    return this.httpClient.get(this.SERVER_URL + 'company-user/CompanyUser/getLoggedUserToCompanyPermissions', {params});
  }

  public deleteUserCompanyAssociation(userUuid) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-user/CompanyUser/deleteUserCompanyAssociation',
      { userUuid },
      { headers });
   }

   public importArticlesForCompany(companyProfileUuid, data, gestiuneId, articleTypeId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/importArticlesForCompany',
      { companyProfileUuid, data, gestiuneId, articleTypeId },
      { headers });
   }

  public getPlans() {
    const params = new HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'client/client/getPlans', {params});
  }
  
  public editPlan(formData: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

    const body = {
      ...formData,         
    };

    return this.httpClient.post(
      this.SERVER_URL + 'client/client/editPlan',
      body,
      { headers }
    );
  }

  public deletePlan(planId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deletePlan',
      { id: planId },
      { headers });
   }

  public getCompaniesOfPlan(planId: any) {
    const params = new HttpParams()
      .set('planId', planId);
    return this.httpClient.get(this.SERVER_URL + 'client/client/getCompaniesOfPlan', {params});
  }

  public getAllPermissions(){
    const params = new HttpParams()
    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllPermissions', {params});
  }

  public getPlanPermissions(planId: any) {
    const params = new HttpParams()
      .set('planId', planId);
    return this.httpClient.get(this.SERVER_URL + 'client/client/getPlanPermissions', {params});
  }

  public updateClientPlan(planId: any, clientId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateClientPlan',
      { planId, clientId },
      { headers });
   }

  public getAllPlanFeatures(): Observable<any> {
    return this.httpClient.get(
      this.SERVER_URL + 'client/client/getAllPlanFeatures'
    );
  }

  public getPlanFeatureCodes(planId: number | string): Observable<any> {
    const params = new HttpParams()
      .set('planId', planId);
    return this.httpClient.get(
      this.SERVER_URL + 'client/client/getPlanFeatureCodes', { params }
    );
  }
  
  public getConvertorBtEmployees() {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'client/client/getConvertorBtEmployees', {params});
  }
 
  public getConvertorBtSourceIbans() {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'client/client/getConvertorBtSourceIbans', {params});
  }
  
  public addConvertorBtEmployee(employee: {
    cnp: string,
    BeneficiaryName: string,
    TargetAccountNumber: string,
    BeneficiaryBankBIC: string,
  }) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/addConvertorBtEmployee',
      { employee },
      { headers });
  }

  public addConvertorBtIban(iban: {
    SourceAccountNumber: string,
    description: string
  }) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/addConvertorBtIban',
      { iban },
      { headers });
  }
  
  public updateConvertorBtEmployee(employee: {
    cnp: string,
    BeneficiaryName: string,
    TargetAccountNumber: string,
    BeneficiaryBankBIC: string,
  }) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateConvertorBtEmployee',
      { employee },
      { headers });
  }
  
  public updateConvertorBtIban(iban: {
    SourceAccountNumber: string,
    description: string
  }) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateConvertorBtIban',
      { iban },
      { headers });
  }
  
  public deleteConvertorBtEmployee(cnp: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteConvertorBtEmployee',
      { cnp },
      { headers });
  }
  
  public deleteConvertorBtIban(iban: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteConvertorBtIban',
      { iban },
      { headers });
  }

}
